import { AutogenModelServiceIncidentOrders, AutogenRowServiceIncidentOrders } from "./autogen/AutogenModelServiceIncidentOrders";

export class ModelServiceIncidentOrders extends AutogenModelServiceIncidentOrders<RowServiceIncidentOrders> {
	constructor() {
		super(RowServiceIncidentOrders);
	}
}

export class RowServiceIncidentOrders extends AutogenRowServiceIncidentOrders {
}